<div class="no-item d-flex align-items-center justify-content-center w-100 flex-column gap-huge">
  <!-- Pic and Title -->
  <div class="d-flex flex-column gap-minus align-items-center justify-content-center">
    <div class="no-item-image"></div>
    <div class="no-item-title bt-2 text-onback-medium">{{ title() }}</div>
  </div>
  <!-- End Pic and Title -->

  <!-- Button -->
  @if (buttonTitle()) {
    <div class="d-flex justify-content-center">
      <ngx-button
        [mode]="'section'"
        [style]="'fill'"
        (clickHandler)="handleBtnClick($event)"
      >
        {{ buttonTitle() }}
      </ngx-button>
    </div>
  }
  <!-- End Button -->
</div>
